import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=e5361bfc&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5361bfc')) {
      api.createRecord('e5361bfc', component.options)
    } else {
      api.reload('e5361bfc', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=e5361bfc&", function () {
      api.rerender('e5361bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hFCXK7G64gei/JS/comp/childrenage.vue"
export default component.exports